import { defineMessages } from 'react-intl'

export default defineMessages({
  reportIncident: {
    id: 'containers.OrderPage.components.TaskPage.components.ReportIncident.reportIncident',
    defaultMessage: 'Report incident',
  },
})
